import certificationService from "./certificationService";

const processingInboxService = [
    ...certificationService
]

export default processingInboxService;